import React, { useState, useEffect } from 'react';
import '../estilos/Principal.css';
//PARTES
import Robot from '../componentes/Publico/Robot'
import Test from '../componentes/Publico/Test';
//PARTES

const Publico = () => {
    useEffect(() => {

    }, []);

    return (
        <>
        <Test/>
       {/*<Robot/>*/}
       </>
    );
};

export default Publico;


